export const SPEC_SECTION_REGEX = '^\\d{2}\\.\\d{4}$';
